{
  "version": 1,
  "asset_id": "67026873-b28b-45fc-a7ca-b9cda3a8e145",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/67026873-b28b-45fc-a7ca-b9cda3a8e145/form-9465.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/67026873-b28b-45fc-a7ca-b9cda3a8e145/form-9465.jpg",
  "original_filename": "form-9465.jpg",
  "size": 220186,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:39:10Z"
}
